/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListPupilActivitiesParams,
  PaginatedPupilActivities,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Pupil Activities
 */
export const listPupilActivities = (
    params?: MaybeRefOrGetter<ListPupilActivitiesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedPupilActivities>(
      {url: `/pupil_activities`, method: 'GET',
        params, signal
    },
      );
    }




export const getListPupilActivitiesQueryKey = (params?: MaybeRefOrGetter<ListPupilActivitiesParams>,) => {
    return [
    'pupil_activities', ...(params ? [params] : [])
    ] as const;
    }


export const getListPupilActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof listPupilActivities>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListPupilActivitiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupilActivities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPupilActivitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPupilActivities>>> = ({ signal }) => listPupilActivities(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPupilActivities>>, TError, TData>
}

export type ListPupilActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listPupilActivities>>>
export type ListPupilActivitiesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Pupil Activities
 */

export function useListPupilActivities<TData = Awaited<ReturnType<typeof listPupilActivities>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListPupilActivitiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupilActivities>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPupilActivitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






